import React from 'react';
import strings from '../../localization';
import TablePage from '../../common/TablePage';
import { withSnackbar } from 'notistack';
import * as Actions from "../../actions/Actions";
import { withRouter } from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import { bindActionCreators } from "redux";
import { Grid } from '@material-ui/core';
import SelectControl from '../../components/controls/SelectControl';
import IconButton from "@material-ui/core/IconButton";
import { generateExpiryByGraveFIeld, generateReportByArrangedPlot, generateReportByCauseOfDeath } from '../../services/report/ReportService';
import { downloadReport, getDefaultGraveSiteTypes, getGraveSiteTypes } from '../../util/ReviewsUtil';
import { getAllGraveyards } from '../../services/graveyard/GraveyardService';
import { getMonths, getYears } from '../../util/DateUtil';
import { getUsedCausesOfDeath } from '../../services/causeOfDeath/CauseOfDeathService';
import DatePickerControl from '../../components/controls/DatePickerControl';

class ReportByArrangedPlot extends TablePage {

  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      showAdd: false,
      showSerach: false,
      filter: {
        year: { value: -1 },
        month: { id: -1 },
      },
      data: {
        year: { value: -1 },
        month: { id: 0 },
      },
    };
  }

  componentDidMount() {
    this.setState(prevState => ({
      companyId: this.props.auth.user.company.id,
      filter: {
        ...prevState.filter,
      }
    }));

    getAllGraveyards().then(response => {
      this.setState({
        filter: {
          ...this.state.filter,
          graveyards: response.data.entities
        }
      });
    });
  }

  componentWillReceiveProps(nextProps) {
    strings.setLanguage(nextProps.auth.user.language);
  }

  getPageHeader() {
    return <h1>{strings.reportByArrangedPlot.pageTitle}</h1>
  }

  generateReport() {
    let data = {
      companyId: this.state.companyId,
      graveyardId: this.state.data.graveyard.id,
      fromPeriod: this.state.data.fromDate ? this.state.data.fromDate.toISOString() : null,
      toPeriod: this.state.data.toDate ? this.state.data.toDate.toISOString() : null,
      userId: this.props.auth.user.id,
    };
    generateReportByArrangedPlot(data).then(response => {
      if (!response.ok) {
        return;
      }

      this.props.enqueueSnackbar(strings.mainBookOfBuriedList.PDF, { variant: 'success' });
      downloadReport(response, "Pregled uređenih grobnih mesta.pdf");
    })
  }

  render() {
    return (
      <Grid id='table-page'>
        <div className='header'>
          {this.getPageHeader()}
        </div>
        <div className='review-select'>
          <React.Fragment>
            <SelectControl
              options={this.state.filter.graveyards}
              selected={this.state.data.graveyard}
              onChange={this.changeData}
              label={strings.expiryByGraveFieldReview.graveyard}
              placeholder={strings.selectControl.select}
              name={"graveyard"}
              nameKey={"name"}
              valueKey={"id"}
            />
            <DatePickerControl
                label={strings.renewalProcessing.periodFrom}
                placeholder={strings.renewalProcessing.periodFrom}
                name="fromDate"
                onChange={this.changeData}
                date={
                  this.state.data.fromDate
                    ? new Date(this.state.data.fromDate)
                    : this.state.data.fromDate
                }
                isClearable={true}
                dateFormat="dd/MM/yyyy"
            />

            <DatePickerControl
                label={strings.renewalProcessing.periodTo}
                placeholder={strings.renewalProcessing.periodTo}
                name="toDate"
                onChange={this.changeData}
                date={
                  this.state.data.toDate
                    ? new Date(this.state.data.toDate)
                    : this.state.data.toDate
                }
                isClearable={true}
                dateFormat="dd/MM/yyyy"
              />
          </React.Fragment>
        </div>
        <div className="report-button">
          <IconButton onClick={() => this.generateReport()} disabled={!this.state.data.graveyard || !this.state.data.fromDate || !this.state.data.toDate}
          >
            {strings.expiryByGraveFieldReview.generateReport}
          </IconButton>
        </div>
      </Grid>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    changeFullScreen: Actions.changeFullScreen
  }, dispatch);
}

function mapStateToProps({ menuReducers, authReducers, siteDataReducers }) {
  return { menu: menuReducers, auth: authReducers, siteData: siteDataReducers };
}

export default withSnackbar(withRouter(connect(mapStateToProps, mapDispatchToProps)(ReportByArrangedPlot)));
